import { afterNextRender, Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { ToastComponent } from './core/part/toast/toast.component';
import { GoogleTagManager } from './core/services/google-tag-manager/google-tag-manager';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, ToastComponent],
  templateUrl: './app.html',
  styleUrl: './app.scss',
})
export class AppComponent {
  private readonly googleTagManager = inject(GoogleTagManager);

  constructor() {
    afterNextRender(() => {
      this.googleTagManager.initialize();
    });
  }
}
